// extracted by css-extract-rspack-plugin
export default {"UpsellPageContent":"iC3aY"};